
import { BarChart, Bar, XAxis, ResponsiveContainer } from 'recharts';



// const data = [
//     {
//       name: 'Lorem',
//       uv: 4000,
//     },
//     {
//       name: 'Lorem',
//       uv: 3000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2780,
//     },
//     {
//       name: 'Lorem',
//       uv: 1890,
//     },
//     {
//       name: 'Lorem',
//       uv: 2390,
//     },
//     {
//       name: 'Lorem',
//       uv: 3490,
//     },
//     {
//       name: 'Lorem',
//       uv: 4000,
//     },
//     {
//       name: 'Lorem',
//       uv: 3000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2780,
//     },
//     {
//       name: 'Lorem',
//       uv: 1890,
//     },
//     {
//       name: 'Lorem',
//       uv: 2390,

//     },
//     {
//       name: 'Lorem',
//       uv: 3490,
//     },
//     {
//       name: 'Lorem',
//       uv: 4000,
//     },
//     {
//       name: 'Lorem',
//       uv: 3000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2780,
//     },
//     {
//       name: 'Lorem',
//       uv: 1890,
//     },
//     {
//       name: 'Lorem',
//       uv: 2390,
//     },
//     {
//       name: 'Lorem',
//       uv: 3490,
//     },
//     {
//       name: 'Lorem',
//       uv: 4000,
//     },
//     {
//       name: 'Lorem',
//       uv: 3000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2000,
//     },
//     {
//       name: 'Lorem',
//       uv: 2780,
//     },
//     {
//       name: 'Lorem',
//       uv: 1890,
//     },
//     {
//       name: 'Lorem',
//       uv: 2390,
//     },
//     {
//       name: 'Lorem',
//       uv: 3490,
//     },
//     {
//       name: 'Lorem',
//       uv: 2780,
//     },
//     {
//       name: 'Lorem',
//       uv: 1890,
//     },
//     {
//       name: 'Lorem',
//       uv: 2390,
//     },
//     {
//       name: 'Lorem',
//       uv: 3490,
//     },
//   ];


  const RoundedBar = (props : any) => {
    const { fill, x, y, width, height } = props;
  
    // Define the radius for the top corners
    const radius = 5;

    if (height <= 0) {
         return <g></g>
    } 

    
  
    return (
      <g>
        <path
          d={`M${x},${y + radius} 
              A${radius},${radius} 0 0,1 ${x + width},${y + radius} 
              L${x + width},${y + height} 
              L${x},${y + height} 
              L${x},${y + radius} 
              Z`}
          fill={fill}
        />
      </g>
    );
  };


const StatsChart = ({
    data
} : {
    data : any[]
}) => {


    return <>
        <ResponsiveContainer width="100%" height={240}>
            <BarChart data={data}>
                <Bar dataKey="uv" fill="#06C270" barSize={200 / data.length} shape={<RoundedBar />} />
                <XAxis dataKey="name" tickLine={false} />
            </BarChart>
        </ResponsiveContainer>
    </>
}


export default StatsChart

